import { useCallback, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useAppDispatch } from 'App/store';
import {
  createShippingRestriction,
  getCreateShippingRestrictionStatus,
  cleanCreateShippingRestrictionStatus,
} from '../../deliveryMethodsSlice';
import {
  ShippingRestrictionFormValues,
  formValuesToDto,
} from '../../pages/ShippingRestrictionPages/types';

function useCreateShippingRestriction() {
  const dispatch = useAppDispatch();
  const status = useSelector(getCreateShippingRestrictionStatus);

  useEffect(() => {
    dispatch(cleanCreateShippingRestrictionStatus());
  }, [dispatch]);

  const create = useCallback(
    async (formValues: ShippingRestrictionFormValues) => {
      const dto = formValuesToDto(formValues);
      await dispatch(createShippingRestriction(dto));
    },
    [dispatch],
  );

  return {
    create,
    isLoading: status === 'loading',
    isSuccess: status === 'success',
    isError: status === 'error',
    status,
  };
}

export default useCreateShippingRestriction;
